import '@stencil/router';
import 'reflect-metadata';
import '@stencil/redux';

import { h } from '@stencil/core';
import * as Cookies from 'es-cookie';
import { environment } from '../../environments/environment';
import { setToken } from '../../utilities/global';

const AuthenticateRoute = ({ component, ...props }: { [key: string]: any }) => {
  const { useSCPAuth = false } = props;
  return (
    <stencil-route
      {...props}
      routeRender={(props: { [key: string]: any }) => {
        let authToken: string = window['AUTH_TOKEN'] || Cookies.get('auth_token');
        if (!authToken) {
          setToken();
          authToken = window['AUTH_TOKEN'] || Cookies.get('auth_token');
        }

        if (authToken) {
          const Component = component;
          return <Component {...props} {...props.componentProps}></Component>;
        } else {
          // Delay redirecting the user away for 3 seconds. Reload the page if an auth token becomes available
          setTimeout(function () {
            setToken();
            authToken = window['AUTH_TOKEN'] || Cookies.get('auth_token');
            if (!authToken) {
              window.location.href = useSCPAuth
                ? `${environment.scpUrl}/signin?returnUrl=${environment.siteUrl}`
                : `${environment.planolyUrl}/login?returnUrl=${environment.siteUrl}`;
            } else {
              window.location.reload;
            }
          }, 3000);
        }
      }}
    />
  );
};

export { AuthenticateRoute };
